import AOS from 'aos';
import 'aos/dist/aos.css';

document.addEventListener('DOMContentLoaded', _=> {
    console.log(document.querySelector('[data-aos]'))
    if(document.querySelector('[data-aos]')) {
        AOS.init();
    }
})
